import type * as THREE from 'three'
import { estimateThreeTextureBytes } from '@/plugins/mesh/loaders/gltfLowMemory/estimateTextureBytes'
import type { MeshLoadResult } from '@/plugins/mesh/types'

/** 统计本插件持有的可见或未挂载网格；不代表整个 renderer/系统的显存实测。 */
export function estimateLoadedMeshGpuBytes(results: Iterable<MeshLoadResult>): number {
  const buffers = new Set<THREE.BufferAttribute | THREE.InterleavedBuffer>()
  const textures = new Set<THREE.Texture>()
  let bytes = 0
  const addAttribute = (attribute: THREE.BufferAttribute | THREE.InterleavedBufferAttribute) => {
    // Three.js WebGLAttributes 以属性对象（交错时以 data）作为 GPU Buffer 身份。
    const buffer = 'isInterleavedBufferAttribute' in attribute ? attribute.data : attribute
    if (buffers.has(buffer)) return
    buffers.add(buffer)
    bytes += buffer.array.byteLength
  }
  for (const result of results) {
    for (const geometry of result.resources.geometries) {
      for (const attribute of Object.values(geometry.attributes)) addAttribute(attribute)
      if (geometry.index) addAttribute(geometry.index)
      for (const attributes of Object.values(geometry.morphAttributes)) {
        for (const attribute of attributes) addAttribute(attribute)
      }
    }
    for (const primitive of result.primitives) {
      const object = primitive.object as THREE.InstancedMesh
      if (object.isInstancedMesh) {
        addAttribute(object.instanceMatrix)
        if (object.instanceColor) addAttribute(object.instanceColor)
      }
    }
    for (const texture of result.resources.textures) {
      if (textures.has(texture)) continue
      textures.add(texture)
      bytes += estimateThreeTextureBytes(texture)
    }
  }
  return bytes
}
